require('jquery');
Modernizr = require('modernizr');
require("SimpleBarJs");
require("SimpleBarCss");

require('./app/shading_content.coffee')
require('./app/header.coffee')
require('./app/news_popup.coffee')
require('./app/buttom_to_top.coffee')
require('./app/copy_url_share.coffee')
require('./app/search.coffee')
require('./app/video.coffee')
require('./app/page_resources_helper.coffee')

window.pageInitCommonFlag = false

pageInit = ->
  editTitle()
  window.shading = new window.ShadingContent()
  window.shadingContent = [] # содержит массив элементов, которые не затеняются маской
  window.headerObject = new window.Header()
  window.searchObject = new window.Search()
  window.newspopupObject = new window.NewsPopup()
  new window.ButtonToTop()
  new window.Video()
  new window.PageResourcesHelper()
  window.currentScroll = 0
  window.currentScrollSetFlag = false

  if Modernizr.cssgrid
    $('body').removeClass('old-browser-fix-wrapper')
  else
    $('body').addClass('old-browser-fix-wrapper')

  $('.gosbar__notification-list').each ->
    new SimpleBar($(this)[0], { autoHide: false })


editTitle = ->
  meta_title = $('h1').html();

  if window.location.pathname == '/'
    document.title = 'Уполномоченный по правам ребенка в Кемеровской области - Кузбассе'
  else if meta_title && meta_title.length > 0
    document.title = meta_title + ' | Уполномоченный по правам ребенка в Кемеровской области - Кузбассе'
  else
    document.title = 'Уполномоченный по правам ребенка в Кемеровской области - Кузбассе'


$(document).ready ->
  if window.pageInitCommonFlag != true
    pageInit()
  window.pageInitCommonFlag = true

  window.headerObject.editHeaderPosition()


// WEBPACK FOOTER //
// ./assets/javascripts/common.coffee